import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../ui/EmptyState';
import AddToCalendarButton from '../ui/AddToCalendarButton';
import { canRescheduleBooking } from '../../utils/booking';
import '../../styles/MyBookings.css';

function MyBookings({
  isAuthenticated,
  businessId,
  bookings,
  loading,
  deleteBookingId,
  onDelete,
  onReschedule,
  onBookNow,
  defaultExpanded = false,
  bookingActionsDisabled = false,
  salonTitle,
  salonAddress,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (defaultExpanded) setExpanded(true);
  }, [defaultExpanded]);

  return (
    <section className="my-bookings">
      <button
        type="button"
        className="my-bookings-toggle"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        <h2 className="section-title">حجوزاتي</h2>
        <div className="my-bookings-toggle-end">
          {isAuthenticated && (
            <Link
              to="/bookings"
              className="my-bookings-all-link"
              onClick={(e) => e.stopPropagation()}
            >
              عرض الكل
            </Link>
          )}
          <svg
            className={`my-bookings-chevron ${expanded ? 'expanded' : ''}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </button>

      {expanded && (
        <div className="my-bookings-content">
          {!isAuthenticated ? (
            <p className="my-bookings-prompt">
              <Link to={`/login?businessid=${encodeURIComponent(businessId)}`} className="my-bookings-link">
                سجّل الدخول
              </Link>
              {' '}لعرض حجوزاتك وإدارتها
            </p>
          ) : loading ? (
            <p className="my-bookings-status">جاري التحميل...</p>
          ) : bookings.length === 0 ? (
            <EmptyState
              icon="📅"
              title="لا توجد حجوزات"
              message="لم تحجز بعد في هذا المحل"
              actionLabel={bookingActionsDisabled ? undefined : 'احجز الآن'}
              onAction={bookingActionsDisabled ? undefined : onBookNow}
            />
          ) : (
            <ul className="my-bookings-list" role="list">
              {bookings.map((b) => (
                <li key={b.id} className="my-bookings-item">
                  <div className="my-bookings-item-info">
                    <span className="my-bookings-type">{b.booking_type || 'حجز'}</span>
                    <span className="my-bookings-datetime">{b.date} — {b.time}</span>
                  </div>
                  <div className="my-bookings-item-actions">
                    <AddToCalendarButton
                      booking={b}
                      salonTitle={salonTitle}
                      salonAddress={salonAddress}
                      compact
                    />
                    {!bookingActionsDisabled && (
                      <>
                      {onReschedule && canRescheduleBooking(b) && (
                        <button
                          type="button"
                          className="my-bookings-reschedule"
                          onClick={() => onReschedule(b)}
                          disabled={deleteBookingId !== null}
                          title="تغيير الموعد"
                        >
                          تغيير
                        </button>
                      )}
                      <button
                        type="button"
                        className="my-bookings-delete"
                        onClick={() => onDelete(b.id)}
                        disabled={deleteBookingId !== null}
                        title="إلغاء الحجز"
                        aria-label="إلغاء الحجز"
                      >
                        {deleteBookingId === b.id ? '...' : 'إلغاء'}
                      </button>
                      </>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </section>
  );
}

export default MyBookings;
